import { action, flow, observable } from 'mobx';
import { apiState, apiResponse, ApiError } from '../../Api';
import { RootStore } from '../createStore';
import { ValidationError } from '../IValidator';
import { DepositoModel, SituacaoDoDeposito } from './Model';
import { aprovarDeposito, postDeposito, reprovarDeposito } from './Service';

export class DepositoStore {
  @observable public depositoValidationError: ValidationError<{ file: File | null }>;
  @observable public justificativaValidationError: ValidationError<{ justificativa: string }>;
  @observable public depositoState: apiState;

  @observable public deposito: DepositoModel = new DepositoModel();
  @observable public file: File | null = null;
  @observable public justificativa: string;
  @observable public tipoDeposito: string;

  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @action
  setValidationError = (validationError: ValidationError<{ file: File | null }>) => {
    this.depositoValidationError = validationError;
  };

  @action
  setJustificativaError = (validationError: ValidationError<{ justificativa: string }>) => {
    this.justificativaValidationError = validationError;
  }

  @action
  update = (object: string, field: string, value: any) => {
    this[object][field] = value;
  };

  @action
  updateField = (name: string, value: any) => {
    this[name] = value;
  }

  @action
  changeDepositoFile = (value: File | null) => {
    this.file = value;
  };

  @action
  changeTipoDeposito = (value: string) => {
    this.tipoDeposito = value;
  };

  updateDepositoFile = flow(function* (this: DepositoStore) {
    this.depositoState = apiState.loading;
    const monografiaId = this.rootStore.monografiaStore.monografia.id;

    if (this.file) {
      const response: apiResponse<ApiError[]> = yield postDeposito(monografiaId, this.file, this.tipoDeposito);
      this.depositoState = response.status;

      if (response.status == apiState.done) {
        this.deposito = {
          conteudoDoArquivo: this.file,
          conteudoDoArquivoPath: '',
          id: 0,
          situacao: SituacaoDoDeposito.pendente,
          justificativaDaReprovacao: '',
          dataDoDeposito: new Date(),
          identifier: ''
        };
      }

      else if (response.status === apiState.error || response.status === apiState.badRequest)
        this.depositoValidationError!.global = response.data!.flatMap(err => err.errorMessages);
    }
  });

  aprovarDeposito = flow(function* (this: DepositoStore) {
    const deposito = this.deposito;

    if (deposito) {
      const response: apiResponse<ApiError[]> = yield aprovarDeposito(deposito.id!);

      if (response.status === apiState.done) {
        this.deposito.situacao = SituacaoDoDeposito.aprovado;
      }

      if (response.status === apiState.error)
        this.depositoValidationError!.global = response.data!.flatMap(err => err.errorMessages);
    }
  });

  reprovarDeposito = flow(function* (this: DepositoStore) {
    const deposito = this.deposito;

    if (deposito) {
      const response: apiResponse<ApiError[]> = yield reprovarDeposito(
        deposito.id, this.justificativa);

      if (response.status === apiState.done) {
        this.deposito.situacao = SituacaoDoDeposito.reprovado;
      }
      if (response.status === apiState.error) {
        this.depositoValidationError!.global = response.data!.flatMap(err => err.errorMessages);
      }
    }
  });
}
